

















import List from '@/packages/m-list';
import getColors from '@/packages/m-picker/demo/demo1/colors';
import Picker from '@/packages/vmc-picker';
import Vue from 'vue';
import Component from 'vue-class-component';
import MPicker from '../../index';

Vue.component('Picker', Picker);
Vue.use(List);
Vue.use(MPicker);
@Component({
  name: 'Demo1'
})
export default class Demo1 extends Vue {
  public data = [{
    label: '江苏省',
    value: 'JiangSu',
    children: [{
      label: '南京市',
      value: 'NanJing'
    }, {
      label: '苏州',
      value: 'SuZhou'
    }]
  }];
  public value2 = null;
  public data2 = getColors(this.$createElement);
  public value = null;
}
